import CommonModal from "../../../App/commonModal"
import React, { useEffect, useState } from "react";
import { Context,Hooks,Util,Request } from "@xt/xtbase";
import {put_remarkInviteCode} from "@/api/referral";
import { Input, message } from "antd";

const {useTranslation, useDocumentWidth} = Hooks;
const {getOrigin, getUrl} = Util;

function EditRemarkModal (props) {
  const { isShowModal, onClose, getInviteCodeList, remark, id } = props;
  const t = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();
  const [remarkCurrent, setRemarkCurrent] = useState(remark)

  const onChange = (e) => {
    console.log('onChange: ', e.target.value);
    setRemarkCurrent(e.target.value)
  };

  const onSave = () => {
    if(!/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/.test(remarkCurrent)){
      messageApi.open({
        type: 'error',
        content: `${t("console.manage.commentTip", { count: 20 })}`,
      });
      return
    }
    put_remarkInviteCode(id,{
      successPop: true,
      data:{remark: remarkCurrent}
    }).then((result)=>{
      getInviteCodeList()
      onClose()
    })
  };

  return (
    <>
      <CommonModal width={420} title={t("console.link.editComment")} isShowModal={isShowModal} onClose={onClose} closable={false}>
        <div className="EditRemarkModal">
          {contextHolder}
          <div>
            <Input onChange={onChange} defaultValue={remarkCurrent} allowClear showCount maxLength={20} />
          </div>
          <div className="remarkTip">
            {t("console.manage.commentTip", { count: 20 })}
          </div>
          <div className="foot1">
            <div className="cancel" onClick={onClose}>{t("home.cancel")}</div>
            <div className="save" onClick={onSave}>{t("home.save")}</div>
          </div>
        </div>
      </CommonModal>
    </>
  )

}

export default EditRemarkModal